import { AppSignature } from "./app-signature";

export class Board extends AppSignature {
    name: string;
    fullName: string;
    isActive: boolean;
    startDate: string;
    endDate: string;
    sortOrder: number;
}

export class GradeModel extends AppSignature {
    name: string;
    sortOrder: number = 0;
    displayName: string = '';
    checked: boolean;
}

export class SubjectModel extends AppSignature {
    name: string;
    parentBoardID: string;
    parentGradeID: string;
    sortOrder: number;
}

export class GradeDTO {
    grade: GradeModel = new GradeModel();
}